import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import Assign from 'components/Operational/assign';

const SetDistribution = ({ event, options, setDistributionHandler }) => {
  const [selectedDistribution, setSelectedDistribution] = useState();
  const fetchInitialData = useCallback(() => {
    const label = event.generalInfo.distribution.value;
    const [labelObject] = options.filter(f => f.label === label);

    setSelectedDistribution({
      id: labelObject?.id,
      label: event.generalInfo.distribution.value,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const distributionHandler = () => {
    setDistributionHandler(selectedDistribution);
  };

  return (
    <div className={styles.operationalPanel}>
      <Assign
        label="Distribution"
        placeholder="Select Distribution"
        options={options}
        selectedValue={selectedDistribution}
        changeSelectedValue={setSelectedDistribution}
        btnText={'Update'}
        btnSize={'s'}
        btnColor={'primary'}
        btnClick={distributionHandler}
      />
    </div>
  );
};

SetDistribution.propTypes = {
  options: PropTypes.array,
  setDistributionHandler: PropTypes.func,
  event: PropTypes.object,
};

export default SetDistribution;
